import { render } from "./removeResourcePopup.vue?vue&type=template&id=18795d6c"
import script from "./removeResourcePopup.vue?vue&type=script&lang=js"
export * from "./removeResourcePopup.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./popups.less?vue&type=style&index=0&module=true&lang=css&external"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__